export default "__VITE_ASSET__b85e6f40__"